import { Box } from "@mui/material";
import { FormPropertyProps } from "../FormProperty";

export const DateRange = (_props: FormPropertyProps) => {
    return <Box>DATE RANGE</Box>;
};
